import React from 'react'
import parse from "html-react-parser"
import AnchorLink from 'react-anchor-link-smooth-scroll'
import _ from 'lodash'

import Link from "./link"
import Text from "../basic/Text"

const recursivelyGetChildren = (children, link) => {
    return children.map((child) => {
        if (child.children) {
            // console.log("has children!", child)
            return recursivelyGetChildren(child.children, link)
        }

        else {
            // console.log("no children, return", child.data)
            return <Link key={link} to={link}>{child.data}</Link>
        }
    })[0]
}

const linkChecks = (linkNode) => {
    if (linkNode.name === "a" && linkNode.attribs.href && linkNode.attribs.href.indexOf("mailto:") < 0) {
        const regex = /:\/\/(www[0-9]?\.)?(.[^/:]+)/i
        const hostname = linkNode.attribs.href.match(regex) && linkNode.attribs.href.match(regex)[2]
        if (hostname !== "submittable.com") {
            linkNode.attribs.target = "_blank"
        }
    }
    // this is a hack for contentful. The only attribute you can set in rich text is the title of the link
    // so if the rich text is run through the HTMLWrapper and its "title" attribute is "scrollTo" (or email which is below), 
    // then render an anchor link to whatever is inside #xxx-xxx...
    // Also I think in the implementation of <AnchorLink>, it doesn't change the window location so messing up utms is unlikely
    if (linkNode.attribs?.title === "scrollTo") {
        return <AnchorLink offset="85" href={linkNode.attribs.href.slice(linkNode.attribs.href.indexOf('#'), linkNode.attribs.href.length)}>{linkNode.children[0].data}</AnchorLink>
    }
    // same with email:
    if (linkNode.attribs?.title === "email") {

        let email = linkNode.attribs.href.slice(linkNode.attribs.href.lastIndexOf('/') + 1, linkNode.attribs.href.length)

        if (email.indexOf('mailto') < 0) {
            email = "mailto:" + email
        }

        return <a href={email}>{linkNode.children[0].data}</a>
    }
    else {
        // TODO: get <a><strong>...</strong></a> this way:
        // console.log("recursive child return", recursivelyGetChildren(linkNode.children, linkNode.attribs.href))
        return recursivelyGetChildren(linkNode.children, linkNode.attribs.href)
    }
}



export default (html, replaceNode) => {

    const replace = (node) => {
        if (node.name === "a") {
            return linkChecks(node)
        }

        // can pass a replaceNode object, that will search in its keys for this node name
        // and replace it with the value of the key
        // so for example {h2: "h3"} will replace all h2s with h3s
        if (!_.isEmpty(replaceNode) && node.name in replaceNode) {
            return <Text component={replaceNode[node.name]}>
                {node.children.map(child => {
                    if (child.data) {
                        return child.data
                    }
                    if (child.name === "a") {
                        return linkChecks(child)
                        //return <Link to={child.attribs.href}>{child.children[0].data}</Link>
                    }
                })}
            </Text>
        }
        // if (wrapNode) {
        //     return <Text component={wrapNode}>
        //         {node.data}
        //     </Text>
        // }
    }

    return parse(html, { replace })
}